import locale70d58165 from '../../locales/en/en-US.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","silentFallbackWarn":true,"silentTranslationWarn":true,"messages":{"en":{"name":"Eng"},"ar":{"name":"عربي"}}},
  vueI18nLoader: true,
  locales: [{"code":"en","iso":"en-US","file":"en/en-US.js","dir":"ltr","name":"EN"},{"code":"ar","iso":"ar-AE","file":"ar/ar-AE.js","dir":"rtl","name":"عربي"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "~/locales/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.dfm.ae",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"kyc":false},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: true,
  exclude: ["/kyc"],
  normalizedLocales: [{"code":"en","iso":"en-US","file":"en/en-US.js","dir":"ltr","name":"EN"},{"code":"ar","iso":"ar-AE","file":"ar/ar-AE.js","dir":"rtl","name":"عربي"}],
  localeCodes: ["en","ar"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "/",
  5: "e",
  6: "n",
  7: "-",
  8: "U",
  9: "S",
  10: ".",
  11: "j",
  12: "s",
  13: "\"",
  14: ":",
  15: "\"",
  16: ".",
  17: ".",
  18: "/",
  19: "l",
  20: "o",
  21: "c",
  22: "a",
  23: "l",
  24: "e",
  25: "s",
  26: "/",
  27: "e",
  28: "n",
  29: "/",
  30: "e",
  31: "n",
  32: "-",
  33: "U",
  34: "S",
  35: ".",
  36: "j",
  37: "s",
  38: "\"",
  39: ",",
  40: "\"",
  41: "a",
  42: "r",
  43: "/",
  44: "a",
  45: "r",
  46: "-",
  47: "A",
  48: "E",
  49: ".",
  50: "j",
  51: "s",
  52: "\"",
  53: ":",
  54: "\"",
  55: ".",
  56: ".",
  57: "/",
  58: "l",
  59: "o",
  60: "c",
  61: "a",
  62: "l",
  63: "e",
  64: "s",
  65: "/",
  66: "a",
  67: "r",
  68: "/",
  69: "a",
  70: "r",
  71: "-",
  72: "A",
  73: "E",
  74: ".",
  75: "j",
  76: "s",
  77: "\"",
  78: "}",
}

export const localeMessages = {
  'en/en-US.js': () => Promise.resolve(locale70d58165),
  'ar/ar-AE.js': () => import('../../locales/ar/ar-AE.js' /* webpackChunkName: "lang-ar/ar-AE.js" */),
}
